import React from 'react'

export const RecommendedNotificationFilled = React.memo((props: { className?: string; fill: string }) => (
    <svg
        className={props.className}
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.20685 10.9924C7.48004 10.9924 7.74212 11.0983 7.93533 11.2865C8.12855 11.4747 8.23718 11.73 8.23718 11.9962C8.23717 12.2624 8.12854 12.5177 7.93533 12.7059C7.74212 12.894 7.48002 13 7.20685 13C6.93372 12.9999 6.67152 12.8941 6.47838 12.7059C6.28526 12.5177 6.17654 12.2623 6.17653 11.9962C6.17653 11.7301 6.28528 11.4747 6.47838 11.2865C6.67152 11.0983 6.93372 10.9925 7.20685 10.9924Z"
            fill={props.fill ?? '#7DB8A3'}
        />
        <path
            d="M7.22295 8.29462C8.51722 8.29462 9.69898 8.75897 10.6037 9.52586C10.6568 9.57129 10.6637 9.64957 10.6188 9.70133L10.0392 10.3748C9.99254 10.428 9.90981 10.434 9.85512 10.3885C9.15323 9.78788 8.23227 9.42391 7.22295 9.42391C6.21369 9.424 5.29262 9.78826 4.59079 10.3905C4.53606 10.4356 4.45423 10.429 4.40767 10.3758L3.82811 9.7033C3.80664 9.67818 3.79565 9.64571 3.79792 9.61311C3.80032 9.5804 3.81621 9.5498 3.84119 9.52782C4.74747 8.75935 5.92874 8.29471 7.22295 8.29462Z"
            fill={props.fill ?? '#7DB8A3'}
        />
        <path
            d="M7.2632 5.4714C7.33192 5.87574 7.46264 6.25946 7.64555 6.61343C7.50583 6.60541 7.36472 6.60069 7.22295 6.60069C5.50214 6.60077 3.9234 7.20032 2.69515 8.19463C2.64206 8.23852 2.55913 8.23219 2.51404 8.17895L1.93448 7.50549C1.91275 7.4799 1.90229 7.44644 1.9053 7.41334C1.90841 7.38032 1.92456 7.34946 1.95058 7.32806C3.38007 6.16904 5.21717 5.47148 7.22295 5.4714C7.23626 5.4714 7.24991 5.47133 7.2632 5.4714Z"
            fill={props.fill ?? '#7DB8A3'}
        />
        <path
            d="M7.19076 2.64817C7.4095 2.64817 7.62706 2.65585 7.84276 2.66777C7.62217 3.00763 7.45201 3.38174 7.3437 3.7804C7.29291 3.77967 7.24172 3.77746 7.19076 3.77746C4.76479 3.77754 2.5383 4.6043 0.788441 5.98605C0.735359 6.02817 0.655386 6.01997 0.610347 5.9684L0.0307884 5.29592C0.0196989 5.28314 0.0107557 5.26779 0.00563396 5.25181C0.000599362 5.23597 -0.00101146 5.21931 0.000603071 5.2028C0.00225327 5.18614 0.00753271 5.16949 0.0156958 5.15476C0.0238393 5.14019 0.0346111 5.12693 0.0478935 5.11653C1.99737 3.57327 4.4831 2.64825 7.19076 2.64817Z"
            fill={props.fill ?? '#7DB8A3'}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0649 3.78062L10.6741 2H11.5631L12.1723 3.78062L14 4.37416V5.24029L12.1723 5.83383L11.5631 7.61445H10.6741L10.0649 5.83383L8.23726 5.24029V4.37416L10.0649 3.78062Z"
            fill={props.fill ?? '#7DB8A3'}
        />
    </svg>
))
